/* eslint-disable react/jsx-no-undef */
import React from "react";
import Container from "@mui/material/Container";
import { useNavigate, useLocation } from "react-router-dom";
import TopBanner from "../../components/layout/TopBanner";
import { useDispatch } from "react-redux";
import TopLogo from "../../components/layout/TopLogo";
import RepairProducts from "../../assets/images/products/fluent_wrench-16-regular.svg";
import RepairProductsDis from "../../assets/images/products/fluent_wrench-16-disabled.svg";
import { SearchProductById, SearchProductWorkOrder } from "../../services/Product";
import dayjs from "dayjs";
import SecondaryButton from "../../components/button/SecondaryButton";
import Blue from "../../assets/images/products/color-blue.svg";
import Yellow from "../../assets/images/products/color-yellow.svg";
import Gray from "../../assets/images/products/color-Gray.svg";
import Green from "../../assets/images/products/color-green.svg";
import Red from "../../assets/images/products/color-red.svg";
import useWindowDimensions from "../../functions/getScreen";

export default function ProductsDetail() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();


  const [productInfo, setProductInfo] = React.useState(null);
  const [warrantyInfoList, setWarrantyInfoList] = React.useState([]);
  const [workOrder, setWorkOrder] = React.useState([]);
  const { width } = useWindowDimensions();
  const height = (width - 32) / 2

  React.useEffect(() => {
    getSearchProductById();
    getSearchProductWorkOrder();
  }, []);

  async function getSearchProductById() {
    try {
      const { data } = await SearchProductById(state.productId);
      if (data.resultCode === 20000) {
        setProductInfo(data.body.info)
        setWarrantyInfoList(data.body.warrantyInfo)
      }

    } catch (error) {
      console.log(" getSearchProductById error", error);
    }
  }

  async function getSearchProductWorkOrder() {
    try {
      const { data } = await SearchProductWorkOrder({ data: { productWarrantyId: state.productId, limit: 100, offset: 0 } });
      if (data.resultCode === 20000) {
        setWorkOrder(data.body.workOrders)
      }
    } catch (error) {
      console.log("getSearchProductWorkOrder", error);
    }
  }

  return (
    <>
      <form>
        <TopLogo />
        <TopBanner type="product" />
        {productInfo &&
          <Container
            maxWidth="xl"
            className="mt-[-31px]"
            style={{ backgroundColor: "#005AAA", paddingBottom: "24px" }}
          >
            <div className="card">
              <div className="card-detail" style={{ minHeight: `${height}px`, width: `${width - 32}px` }}>
                <div
                  className="pt-[60px] pl-[50px] w-full"
                  style={{ lineHeight: "100%" }}
                >
                  <p className="primary-color text-[12px]">
                    {productInfo.typeName}
                  </p>
                  <p className="primary-color text-[24px]">{productInfo.code}</p>
                  <p className="primary-color text-[16px]">{productInfo.modelName}</p>
                  <div className="pt-[12px]">
                    <p className="primary-color text-[12px]">Serial numbers</p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      lineHeight: "80%",
                      justifyContent: "space-between",
                      textAlign: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className="px-[16px] py-[5px]"
                      style={{ backgroundColor: "#005AAA" }}
                    >
                      <p className="text-white text-[20px]">
                        {productInfo.serialNumber}
                      </p>
                    </div>
                    <div className="text-right pr-[25px]">
                      <p className="secondary-color text-[8px]">วันที่ซื้อ:</p>
                      <p className="primary-color text-[14px]">{dayjs(productInfo.buyDate).format('DD/MM/YYYY')}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="bg-white"
              style={{
                padding: "0 10px",
                margin: "24px 5px 0px 5px",
                borderRadius: "10px",
              }}
            >
              <div className="px-[10px]">
                <div className="flex gap-[10px] justify-start  pt-[20px]">
                  <div className="primary-color title-size">ข้อมูลสินค้า</div>
                  <div style={{ marginTop: "6px" }}>
                    <p className="sub-title-size">Product Information</p>
                    <div className="blue-line"></div>
                  </div>
                </div>
              </div>

              <div className="w-full px-[10px] pb-[10px]">
                <div className="products-detail">
                  <p className="secondary-color">ยี่ห้อ:</p>
                  <p>{productInfo.brandName}</p>
                </div>
                <div className="products-detail">
                  <p className="secondary-color">ประเภท:</p>
                  <p>{productInfo.typeName}</p>
                </div>
                <div className="products-detail">
                  <p className="secondary-color">ชื่อรุ่น:</p>
                  <p>{productInfo.code}</p>
                </div>
                <div className="products-detail">
                  <p className="secondary-color">Serial Number:</p>
                  <p>{productInfo.serialNumber}</p>
                </div>
                <div className="products-detail">
                  <p className="secondary-color">รหัสสินค้า:</p>
                  <p>{productInfo.modelName}</p>
                </div>
                <div className="products-detail">
                  <p className="secondary-color">วันที่ซื้อ:</p>
                  <p>{dayjs(productInfo.buyDate).format('DD/MM/YYYY')}</p>
                </div>
                <div className="products-detail">
                  <p className="secondary-color">วันหมดอายุประกัน:</p>
                  <p>{productInfo.expireDate ? dayjs(productInfo.expireDate).format('DD/MM/YYYY') : '-'}</p>
                </div>
                <div className="products-detail">
                  <p className="secondary-color">ใบเสร็จ:</p>
                  <p>อัพโหลดแล้ว</p>
                </div>
                <div className="products-detail mt-[15px]">
                  <button className="btn-repair ml-auto" onClick={() => navigate('/notify-repair', { state: { memberId: state.memberId, productId: state.productId } })}>
                    <img className="w-[14px] mt-[-2px]" src={RepairProducts} alt="" />
                    <p className="text-[20px]">แจ้งซ่อม</p>
                  </button>
                </div>
              </div>
              {warrantyInfoList.length > 0 &&
                <>
                  <div className="px-[10px]">
                    <div className="flex gap-[10px] justify-start  pt-[0px]">
                      <div className="primary-color title-size">ประกันสินค้า</div>
                      <div style={{ marginTop: "6px" }}>
                        <p className="sub-title-size">Product Warranty</p>
                        <div className="blue-line"></div>
                      </div>
                    </div>
                  </div>

                  <div className="w-full px-[10px] pb-[30px]">
                    {warrantyInfoList.map((item, index) => (
                      <div key={index}>
                        <div className="products-detail">
                          <p className="secondary-color">{item.part}:</p>
                          <p>{dayjs(item.expireDate).format('DD/MM/YYYY')}</p>
                        </div>
                      </div>
                    ))}

                  </div>
                </>
              }
            </div>
            {workOrder.length > 0 &&
              <hr className="solid mt-[24px]"></hr>
            }

            {workOrder.length > 0 &&

              < div className="px-[5px]">
                <div className="flex gap-[10px] justify-start ml-[35px] pt-[20px]">
                  <div className="text-white text-[34px]">ประวัติการซ่อม</div>
                  <div style={{ marginTop: "6px" }}>
                    <p className="sub-title-size text-white">Repair History</p>
                    <div className="white-line"></div>
                  </div>
                </div>
                <div className="container-repair">

                  {workOrder.map((item, index) => (
                    <div key={index}>
                      <div className="repair-history">
                        <div className="Item1">
                          <div className="secondary-color">รหัสการซ่อม</div>
                          <div className="repair-data">{item.order}</div>
                        </div>
                        <div className="Item2">
                          <div className="secondary-color">สถานะการซ่อม</div>
                          <div className="status-repair">
                            {item.status === 'เปิดงานซ่อมเรียบร้อยแล้ว' ?
                              <>
                                <img className="w-[10px]" src={Blue} alt="" />
                                <p className="repair-data">
                                  เปิดงานซ่อม <br /> เรียบร้อยแล้ว
                                </p>
                              </> : item.status === 'ศูนย์บริการรับเรื่องแล้ว' ?
                                <>
                                  <img className="w-[10px]" src={Yellow} alt="" />
                                  <p className="repair-data">
                                    ศูนย์บริการ <br /> รับเรื่องแล้ว
                                  </p>
                                </>
                                : item.status === 'อยู่ระหว่างดำเนินการ' ?
                                  <>
                                    <img className="w-[10px]" src={Gray} alt="" />
                                    <p className="repair-data">
                                      อยู่ระหว่าง <br /> ดำเนินการ
                                    </p>
                                  </>
                                  : item.status === 'เสร็จสมบูรณ์' ?
                                    <>
                                      <img className="w-[10px]" src={Green} alt="" />
                                      <p className="repair-data">เสร็จสมบูรณ์</p>
                                    </>
                                    :
                                    <>
                                      <img className="w-[10px]" src={Red} alt="" />
                                      <p className="repair-data">งานซ่อมถูกยกเลิก</p>
                                    </>
                            }
                          </div>
                        </div>
                        <div className="Item3">
                          <div className="secondary-color">วันที่</div>
                          <div className="repair-data">{dayjs(item.date).format('DD/MM/YYYY')}</div>
                        </div>
                      </div>
                    </div>
                  ))}

                </div>
                {/* <div className="flex gap-[10px] justify-center ml-[35px] pt-[20px]">
                  <div className="text-[#B0C0DA] text-[20px]">Loading ...</div>
                  <div style={{ marginTop: "6px" }}></div>
                </div> */}
              </div>
            }

          </Container>
        }
        <div className="bg-white h-[100px] pt-[25px]">
          <div className="mx-[30px]">
            <SecondaryButton variant="outlined" className="w-[100%]" onClick={() => navigate(-1)}>
              ย้อนกลับ
            </SecondaryButton>
          </div>
        </div>
      </form >
    </>
  );
}
